/// <amd-module name="VSSUI/Components/PersonaCard/DefaultSimpleCard" />
import * as React from "react";
import { VssPersona } from "VSSUI/VssPersona";
import { ContactCardProps } from "./ContactCard.Props";

/** @deprecated */
export class DefaultSimpleCard extends React.Component<ContactCardProps> {
    // Render
    public render(): JSX.Element {
        const mainPersonaData = {
            imageUrl: this.props.identity.image,
            primaryText: this.props.identity.displayName,
            secondaryText:
                this.props.identity.scopeName && this.props.identity.signInAddress
                    ? this.props.identity.scopeName + "\\" + this.props.identity.signInAddress
                    : this.props.identity.signInAddress
                    ? this.props.identity.signInAddress
                    : ""
        };

        return (
            <div className="default-card-simple flex-row">
                {/* Main persona display */}
                <div className="flex-row">
                    <VssPersona
                        className="persona-main"
                        displayName={mainPersonaData.primaryText}
                        imageUrl={ mainPersonaData.imageUrl ? mainPersonaData.imageUrl+"?size=2" : undefined}
                        suppressPersonaCard={true}
                        size="extra-large"
                    />
                    <div className="flex-column flex-grow persona-card-name">
                        <div className="persona-main-text-primary">{mainPersonaData.primaryText}</div>
                        {mainPersonaData.secondaryText === "" ? undefined : <div className="persona-main-text-secondary">{mainPersonaData.secondaryText}</div>}
                    </div>
                </div>
            </div>
        );
    }
}
